'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = bouncerMiddleware;

var _ircFramework = require('irc-framework');

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bouncerMiddleware() {
    var networks = [];
    var buffers = {};

    return function middleware(client, rawEvents, parsedEvents) {
        client.requestCap('bouncer');
        addFunctionsToClient(client);
        rawEvents.use(theMiddleware);
    };

    function theMiddleware(command, message, rawLine, client, next) {
        if (command !== 'BOUNCER') {
            next();
            return;
        }

        var params = message.params;

        if (params[0] === 'listnetworks' && ['end', 'RPL_OK'].indexOf(params[1]) > -1) {
            client.emit('bouncer networks', networks);
            networks = [];
        } else if (params[0] === 'listnetworks') {
            var tags = _ircFramework.MessageTags.decode(params[1]);
            networks.push({
                name: tags.network,
                host: tags.host,
                port: parseInt(tags.port, 10),
                tls: tags.tls === '1',
                connect: tags.state === 'connected',
                nick: tags.nick,
                currentNick: tags.currentNick,
                password: tags.password || ''
            });
        } else if (params[0] === 'listbuffers' && ['end', 'RPL_OK'].indexOf(params[2]) > -1) {
            var netName = (params[1] || '').toLowerCase();
            var detectedBuffers = buffers[netName] || [];
            delete buffers[netName];

            client.emit('bouncer buffers', detectedBuffers);
            client.emit('bouncer buffers ' + netName, detectedBuffers);
        } else if (params[0] === 'listbuffers') {
            var _netName = (params[1] || '').toLowerCase();
            var _tags = _ircFramework.MessageTags.decode(params[2]);
            buffers[_netName] = buffers[_netName] || [];
            buffers[_netName].push({
                network: _tags.network,
                name: _tags.buffer,
                topic: _tags.topic,
                joined: _tags.joined === '1',
                seen: _tags.seen
            });
        }

        if (params[0] === 'addnetwork' && params[2].substr(0, 4) === 'ERR_') {
            var _netName2 = (params[1] || '').toLowerCase();
            var eventObj = {
                error: params[2],
                reason: params[3] || ''
            };
            client.emit('bouncer addnetwork error', eventObj);
            client.emit('bouncer addnetwork error ' + _netName2, eventObj);
        } else if (params[0] === 'addnetwork' && ['end', 'RPL_OK'].indexOf(params[2]) > -1) {
            var _netName3 = (params[1] || '').toLowerCase();
            var _eventObj = {
                network: params[2]
            };
            client.emit('bouncer addnetwork ok', _eventObj);
            client.emit('bouncer addnetwork ok ' + _netName3, _eventObj);
        }
    }
}

function addFunctionsToClient(client) {
    var bnc = client.bnc = {};

    bnc.tags = function tags() {
        var token = client.network.supports('bouncer');
        return !token || typeof token !== 'string' ? {} : _ircFramework.MessageTags.decode(token) || {};
    };

    bnc.hasNetwork = function hasNetwork() {
        var token = client.network.supports('bouncer');
        if (!token || token === true) {
            return false;
        }

        var tags = _ircFramework.MessageTags.decode(token);
        return tags && !!tags.network;
    };

    bnc.getNetworks = function getNetworks() {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER listnetworks');
            client.once('bouncer networks', function (networks) {
                resolve(networks);
            });
        });
    };

    bnc.getBuffers = function getBuffers(netName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER listbuffers ' + netName);
            client.once('bouncer buffers ' + netName.toLowerCase(), function (buffers) {
                resolve(buffers);
            });
        });
    };

    bnc.closeBuffer = function closeBuffer(netName, bufferName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER delbuffer ' + netName + ' ' + bufferName);
        });
    };

    bnc.bufferSeen = function bufferSeen(netName, bufferName, seenTime) {
        return new _promise2.default(function (resolve, reject) {
            var timeStr = Misc.dateIso(seenTime);
            client.raw('BOUNCER changebuffer ' + netName + ' ' + bufferName + ' seen=' + timeStr);
        });
    };

    bnc.addNetwork = function addNetwork(netName, host, port, tls, nick, user, password) {
        var tags = {};
        tags.network = netName;
        tags.host = host;
        tags.port = port;
        tags.tls = tls ? 1 : 0;
        tags.nick = nick;
        tags.password = password;

        if (user) {
            tags.user = user;
        }

        var tagString = createTagString(tags);
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER addnetwork ' + tagString);
            client.once('bouncer addnetwork ok', onOk);
            client.once('bouncer addnetwork error', onError);

            function onOk(event) {
                client.off('bouncer addnetwork error', onError);
                resolve();
            }
            function onError(event) {
                client.off('bouncer addnetwork ok', onOk);
                reject({
                    error: event.error,
                    reason: event.reason
                });
            }
        });
    };

    bnc.removeNetwork = function removeNetwork(netName, bufferName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER delnetwork ' + netName);
        });
    };

    bnc.saveNetwork = function saveNetwork(netName, opts) {
        var tags = {};

        if (typeof opts.host !== 'undefined') {
            tags.host = opts.host;
        }
        if (typeof opts.port !== 'undefined') {
            tags.port = opts.port;
        }
        if (typeof opts.tls !== 'undefined') {
            tags.tls = opts.tls ? 1 : 0;
        }
        if (typeof opts.nick !== 'undefined') {
            tags.nick = opts.nick;
        }
        if (typeof opts.user !== 'undefined') {
            tags.user = opts.user;
        }
        if (typeof opts.password !== 'undefined') {
            tags.password = opts.password;
        }

        var tagString = createTagString(tags);
        return new _promise2.default(function (resolve, reject) {
            if (tagString.length === 0) {
                resolve();
            } else {
                client.raw('BOUNCER changenetwork ' + netName + ' ' + tagString);
            }
        });
    };
}

function createTagString(tags) {
    var tagParts = [];

    (0, _keys2.default)(tags).forEach(function (tag) {
        var val = tags[tag];
        if (typeof val !== 'undefined') {
            val = val.toString().replace(' ', '\\s').replace(';', '\\:');
            tagParts.push(tag + '=' + val);
        } else {
            tagParts.push(tag);
        }
    });

    return tagParts.join(';');
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerMiddleware"]
window._kiwi_exports.libs.BouncerMiddleware = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/BouncerMiddleware.js
// module id = 2j2C
// module chunks = 1